import { useReactiveVar } from '@apollo/client';
import { commands } from '../operations/commands';
import { chartConstructVar } from '../cache';
var useChartConstruct = function () {
    var setChartConstruct = commands.setChartConstruct;
    var chartConstruct = useReactiveVar(chartConstructVar);
    return { chartConstruct: chartConstruct, setChartConstruct: setChartConstruct };
};
export default useChartConstruct;
